import { render } from "./CertificationIntro.vue?vue&type=template&id=5762de8c&scoped=true"
import script from "./CertificationIntro.vue?vue&type=script&lang=js"
export * from "./CertificationIntro.vue?vue&type=script&lang=js"

import "./CertificationIntro.vue?vue&type=style&index=0&id=5762de8c&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5762de8c"]])

export default __exports__